export default __webpack_public_path__ + "static/media/SndLowerSTurnDowm.2399c158.mp3";